export const SITE_LINKS = {
  AUTH: {
    LOGIN: '/login',
    FORGOT_PASSWORD: '/forgot-password',
    SET_NEW_PASSWORD: '/set-new-password',
    MFA: '/mfa',
    RESET_SUCCESS: '/reset-success'
  }
}
